import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import HeadingContainer from "../../../layout/heading-container";
import { HeadlineMedium } from "../../../components/font";
import { Button, IllustrationPuzzle } from "@manifesthhqinc/ui-library";
import { VectorWrapperDiv } from "../../../components/vector-wrapper/styles";

const ProviderKnownScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, isSaving, setIsSaving } = props;

  const onClickContinueHandler = () => {
    setIsSaving(true);
    onClickContinue();
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">
              We’ll verify your old <br />
              account details for you!
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapperDiv $marginTop={-30}>
            <IllustrationPuzzle width={260} height={260} />
          </VectorWrapperDiv>
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="text-center form-description-with-vector disclaimer-text no-max-width">
          Manifest uses trusted resources to confirm your old account details. Our database search ensures all
          information is up to date.
        </p>
        <Button name="continue" onClick={onClickContinueHandler} isLoading={isSaving} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ProviderKnownScreen;
